import { WorkOSCallbackPage } from '@features/auth/components/WorkOSCallbackPage';
import { OAuthCallbackSearchSchema } from '@routes/searchSchemas';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sso/callback')({
  validateSearch: OAuthCallbackSearchSchema,
  component: WorkOSCallbackPage,
});
